module.exports = __webpack_public_path__ + "static/media/latymerCourt4.1b34e1b1.jpg";